import type React from 'react';

const ItalicIcon: React.FC = () => (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.822 36" width="18.822" height="36">
        <path d="M6.936 0l-.814 4.387h3.466l-5.3 27.23H.818L0 36h11.832l.819-4.383h-3.47l5.3-27.23H18L18.822 0z" />
    </svg>
);

export default ItalicIcon;
